// extracted by mini-css-extract-plugin
export default {"productGallery":"DH-z","inQuickShop":"EH-z"};